<template>
  <div>
    <div class="px-24 py-12">
      <div class="flex max-h-40 flex-row space-x-24">
        <Title :quantity />

        <ScrollWrapper class="hidden w-full md:block" :length="itemsCount">
          <CartItems :items="[items[0]]" />
          <TradeIn :trade-in />
          <CartItems v-if="items.length > 1" :items="items.slice(1)" />
        </ScrollWrapper>
      </div>
    </div>
    <div class="bg-surface-default-hi w-full">
      <div
        class="bg-action-default-hi h-3 w-[90%] transition-width duration-500 ease-out motion-reduce:transition-none"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import CartItems from './components/CartItems/CartItems.vue'
import ScrollWrapper from './components/ScrollWrapper/ScrollWrapper.vue'
import Title from './components/Title/Title.vue'
import TradeIn from './components/TradeIn/TradeIn.vue'

const props = defineProps<{
  items: Array<{
    listingId: number
    image: string
    title: string
    quantity: number
  }>
  tradeIn: string | null
}>()

const quantity = computed(() =>
  props.items.reduce((total, item) => total + item.quantity, 0),
)

const itemsCount = computed(() =>
  props.tradeIn ? props.items.length + 1 : props.items.length,
)
</script>
